import throttle from 'lodash/throttle';
import BaseComponent from 'foundation/base-component';

export default class FinalLeaderboard extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.finalLeaderboardWrapper = this.refs.finalLeaderboardWrapper;
        this.arrowRight = this.refs.arrowRight;
        this.arrowLeft = this.refs.arrowLeft;

        this.endPositionNode = this.refs.endPositionNode;
        this.startPositionNode = this.refs.startPositionNode;

        this.init();
    }

    static getRequiredRefs() {
        return [
            'finalLeaderboardWrapper',
            'arrowRight',
            'arrowLeft',
            'startPositionNode',
            'endPositionNode',
        ];
    }
    init() {
        this.addListener(this.finalLeaderboardWrapper, 'scroll', throttle(this.onScroll, 50));
    }

    onScroll = () => {
        const arrowRightCoordinateLeft = this.arrowRight.getBoundingClientRect().left;
        const endPositionNodeCoordinateLeft = this.endPositionNode.getBoundingClientRect().left;
        const arrowLeftCoordinateLeft = this.arrowLeft.getBoundingClientRect().left;
        const startPositionNodeCoordinateLeft = this.startPositionNode.getBoundingClientRect().left;

        if (arrowRightCoordinateLeft >= endPositionNodeCoordinateLeft) {
            this.arrowRight.classList.add('animation');
        } else {
            this.arrowRight.classList.remove('animation');
        }

        if (arrowLeftCoordinateLeft >= startPositionNodeCoordinateLeft) {
            this.arrowLeft.classList.add('animation');
        } else {
            this.arrowLeft.classList.remove('animation');
        }
    }
}
